module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"deleteEntityCard.placeholder":"Enter \u0027{entityName}\u0027 to continue","deleteEntityCard.checkToDelete.label":"Are you sure you want to delete?"}}')
  delete Component.options._Ctor
}
